<template>
  <div class="phonePage">
    <!-- 统计卡片 -->
    <div class="statsCard">
      <div class="cardHeader">
        <div class="headerLeft">
          <h1>设备离线状态</h1>
          <p class="subtitle">数据每整点统计一次</p>
        </div>
        <van-button
          size="small"
          type="primary"
          color="#2ad1c4"
          @click="getall"
          icon="replay"
        >
          刷新
        </van-button>
      </div>
      <div class="statItem">
        <div class="statLabel">
          <span>设备总数量</span>
          <van-popover v-model="showTooltip1" trigger="click" placement="top">
            <div class="tooltip-content">
              <h3>已过滤(相关打标签设备)</h3>
              <div class="tag-list">
                <van-tag>撤机</van-tag>
                <van-tag>测试</van-tag>
                <van-tag>展示</van-tag>
                <van-tag>展会</van-tag>
                <van-tag>已切</van-tag>
                <van-tag>已废</van-tag>
                <van-tag>待撤</van-tag>
                <van-tag>未使用</van-tag>
                <van-tag>被盗</van-tag>
                <van-tag>景区异常</van-tag>
                <van-tag>待报废</van-tag>
                <van-tag>已移机</van-tag>
              </div>
            </div>
            <template #reference>
              <van-icon name="question-o" class="tooltip-icon" />
            </template>
          </van-popover>
        </div>
        <div class="statValue">{{ totalOnline + totalOffline }}</div>
      </div>
      <div class="statItem">
        <div class="statLabel">
          <span>离线时间>=24小时设备数量</span>
        </div>
        <div class="statValue offline">{{ totalOffline }}</div>
      </div>
    </div>

    <!-- 筛选表单 -->
    <van-form @submit="handleQuery" class="filterForm">
      <van-field
        readonly
        clickable
        name="景区选择"
        :value="storeName || '全部景区'"
        label="景区选择"
        placeholder="点击选择景区（默认全部）"
        @click="handleStorePopUp"
        :right-icon="storeName ? 'clear' : 'arrow'"
        @click-right-icon.stop="clearStore"
      />
      <van-popup v-model="showStorePicker" position="bottom">
        <van-field
          class="searchBox"
          v-model="keyWord"
          center
          placeholder="搜索景区名称"
        >
          <template #button>
            <van-button size="small" type="primary" @click.prevent="keySearch">搜索</van-button>
          </template>
        </van-field>
        <van-picker
          class="storeBox"
          show-toolbar
          toolbar-position="bottom"
          :columns="storeOptions"
          @confirm="onStoreConfirm"
          @cancel="handleStorePickerCancel"
        />
      </van-popup>

      <van-field
        readonly
        clickable
        name="离线时间"
        :value="timeFrameName"
        label="离线时间"
        placeholder="点击选择时间"
        @click="showTimePicker = true"
        right-icon="arrow"
      />
      <van-popup v-model="showTimePicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="timeOptions"
          @confirm="onTimeConfirm"
          @cancel="showTimePicker = false"
        />
      </van-popup>

      <div style="margin: 16px">
        <van-button
          round
          block
          type="primary"
          native-type="submit"
          color="#2ad1c4"
        >
          查询
        </van-button>
      </div>
      <!-- <div style="margin: 0 16px 16px 16px">
        <van-button
          round
          block
          type="default"
          @click="handleDownload"
          icon="down"
        >
          下载
        </van-button>
      </div> -->
    </van-form>

    <!-- 设备离线列表 -->
    <div class="deviceList">
      <div class="listTitle">
        <h3>设备离线列表</h3>
        <van-popover v-model="showTooltip2" trigger="click" placement="top">
          <div class="tooltip-content">
            <p>统计离线时长大于等于24小时的设备</p>
          </div>
          <!-- <template #reference>
            <van-icon name="question-o" class="tooltip-icon" />
          </template> -->
        </van-popover>
      </div>

      <div v-if="offlineList && offlineList.length > 0" class="listContent">
        <div v-for="item in displayedData" :key="item.id" class="listItem">
          <div class="itemName">{{ item.name }}</div>
          <div class="itemTime">已离线{{ item.time }}天</div>
        </div>
      </div>
      <div v-else class="noData">暂无数据...</div>

      <!-- 分页 -->
      <van-pagination
        v-if="offlineList && offlineList.length > 0"
        v-model="currentPage"
        :total-items="offlineList.length"
        :items-per-page="pageSize"
        @change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import {
  getDeviceNum,
  getDeviceOffline,
  getDeviceOfflineDownload,
  getStoreList,
} from "@/api/bi";

export default {
  name: "DeviceNum",
  data() {
    return {
      totalOnline: 0,
      totalOffline: 0,
      store: [],
      storeName: "",
      storeOptions: [],
      allStore: [],
      keyWord: "",
      time_frame: "1",
      timeFrameName: "离线时间大于等于24小时",
      timeOptions: [
        { text: "离线时间大于等于24小时", value: "1" },
        { text: "离线时间大于6小时小于12小时", value: "2" },
      ],
      category: ["1", "2", "3", "4", "5", "6", "7", "8"],
      offlineList: [],
      currentPage: 1,
      pageSize: 20,
      gte: 24,
      lte: 0,
      showStorePicker: false,
      showTimePicker: false,
      showTooltip1: false,
      showTooltip2: false,
    };
  },
  computed: {
    displayedData() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      if (this.offlineList && this.offlineList.length > 0) {
        return this.offlineList.slice(start, end);
      } else {
        return [];
      }
    },
  },
  created() {
    this.getAllStore();
    this.getNum();
    this.getData();
  },
  methods: {
    getall() {
      this.getData();
      this.getNum();
    },
    checktime() {
      if (this.time_frame === "1") {
        this.gte = 24;
        this.lte = 0;
      } else if (this.time_frame === "2") {
        this.lte = 12;
        this.gte = 6;
      }
    },
    getData() {
      this.checktime();
      const params = {
        source: [...this.category],
        lte: this.lte,
        gte: this.gte,
      };
      // 只有当选择了景区时才传递 company_id_list 参数
      if (this.store && this.store.length > 0) {
        params.company_id_list = [...this.store];
      }
      getDeviceOffline(params).then((res) => {
        this.offlineList = [];
        if (res && res.code === 2000 && res.data) {
          if (res.data.constructor.name === "Array") {
            res.data.map((val) => {
              this.offlineList.push({
                name: val.device_name,
                time: val.time,
                id: val.device_id,
              });
            });
          }
        }
        // 重置到第一页
        this.currentPage = 1;
      });
    },
    getNum() {
      getDeviceNum().then((res) => {
        if (res && res.code === 2000 && res.data) {
          this.totalOnline = 0;
          this.totalOffline = 0;
          for (const key in res.data) {
            if (res.data.hasOwnProperty(key)) {
              this.totalOnline += res.data[key].online || 0;
              this.totalOffline += res.data[key].no_online || 0;
            }
          }
        }
      });
    },
    getAllStore() {
      getStoreList()
        .then((res) => {
          if (res && res.code === 2000 && res.data) {
            this.allStore = res.data;
            this.resetStoreList();
          }
        })
        .catch((e) => {
          console.error("获取景区列表失败", e);
        });
    },
    resetStoreList() {
      // 重置景区列表（打开下拉框就要重置）
      this.keyWord = ""; // 关键字清空
      // 添加"全部"选项
      const allOption = [{ text: "全部景区", value: "" }];
      const storeOptions = this.allStore.map((val) => ({
        text: val.name,
        value: val.id,
      }));
      this.storeOptions = [...allOption, ...storeOptions];
    },
    keySearch() {
      // 模糊查询景区
      if (!this.keyWord || this.keyWord.trim() === "") {
        this.resetStoreList();
        return;
      }
      const temp = this.allStore.filter((val) => {
        // 拿全部的数据去搜索
        return val.name.indexOf(this.keyWord) !== -1;
      });
      // 添加"全部"选项
      const allOption = [{ text: "全部景区", value: "" }];
      const storeOptions = temp.map((val) => ({
        text: val.name,
        value: val.id,
      }));
      this.storeOptions = [...allOption, ...storeOptions];
    },
    handleStorePopUp() {
      // 打开景区下拉列表
      this.resetStoreList();
      this.showStorePicker = true; // 打开下拉框选项
    },
    handleStorePickerCancel() {
      // 取消选择时重置列表
      this.resetStoreList();
      this.showStorePicker = false;
    },
    clearStore() {
      // 清空景区选择
      this.store = [];
      this.storeName = "";
      // 清空后自动查询全部数据
      this.handleQuery();
    },
    onStoreConfirm(value) {
      // 如果选择的是"全部景区"
      if (value.value === "") {
        this.store = [];
        this.storeName = "";
      } else {
        const selectedStore = this.allStore.find((s) => s.id === value.value);
        if (selectedStore) {
          this.store = [value.value];
          this.storeName = value.text;
        }
      }
      this.resetStoreList(); // 选择后重置列表
      this.showStorePicker = false;
    },
    onTimeConfirm(value) {
      this.time_frame = value.value;
      this.timeFrameName = value.text;
      this.showTimePicker = false;
    },
    handleQuery() {
      this.currentPage = 1;
      this.getData();
      this.getNum();
    },
    handleCurrentChange(page) {
      this.currentPage = page;
    },
    handleDownload() {
      this.$dialog
        .confirm({
          title: "确认下载",
          message: "确认下载离线状态数据吗？",
        })
        .then(() => {
          this.checktime();
          const params = {
            source: [...this.category],
            lte: this.lte,
            gte: this.gte,
          };
          // 只有当选择了景区时才传递 company_id_list 参数
          if (this.store && this.store.length > 0) {
            params.company_id_list = [...this.store];
          }
          getDeviceOfflineDownload(params)
            .then((data) => {
              this.download(data);
              this.$toast.success("下载成功");
            })
            .catch((error) => {
              this.$toast.fail(error.message || "下载失败");
            });
        })
        .catch(() => {
          // 取消下载
        });
    },
    download(resp) {
      const fileName = "设备离线状态.xlsx";
      const blob = new Blob([resp.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, fileName);
      } else {
        const href = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = href;
        a.download = fileName;
        a.click();
        URL.revokeObjectURL(a.href);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.phonePage {
  width: 90%;
  margin: 3.5em auto 0 auto;
  padding-bottom: 3em;
  box-sizing: border-box;
}

.statsCard {
  background: #fff;
  border-radius: 15px;
  padding: 15px 20px;
  margin-bottom: 15px;
  box-shadow: 0 0 15px rgba(42, 209, 196, 0.15);
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.cardHeader {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-bottom: 15px;
  border-bottom: 1px solid #f0f0f0;
  margin-bottom: 5px;
}

.headerLeft {
  flex: 1;

  h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0 0 5px 0;
    color: #333;
  }

  .subtitle {
    font-size: 12px;
    color: #999;
    margin: 0;
    line-height: 1.4;
  }
}

.statItem {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.statLabel {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 14px;
  color: #666;

  .tooltip-icon {
    color: #2ad1c4;
    font-size: 16px;
  }
}

.statValue {
  font-size: 28px;
  font-weight: bold;
  background: linear-gradient(to right, #2ad1c4, #1db5a8);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;

  &.offline {
    background: linear-gradient(to right, #ff7c7c, #ff5252);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
}

.tooltip-content {
  padding: 10px;

  h3 {
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .tag-list {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
  }

  p {
    font-size: 12px;
    margin: 0;
  }
}

.filterForm {
  background: #fff;
  border-radius: 15px;
  padding: 15px 10px;
  margin-bottom: 15px;
  box-shadow: 0 0 15px rgba(42, 209, 196, 0.15);
}

.deviceList {
  background: #fff;
  border-radius: 15px;
  padding: 15px;
  box-shadow: 0 0 15px rgba(42, 209, 196, 0.15);
}

.listTitle {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 15px;

  h3 {
    font-size: 16px;
    font-weight: bold;
    margin: 0;
    color: #333;
  }

  .tooltip-icon {
    color: #2ad1c4;
    font-size: 16px;
  }
}

.listContent {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.listItem {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 10px;
  border-left: 3px solid #2ad1c4;
}

.itemName {
  font-size: 14px;
  color: #333;
  flex: 1;
  word-break: break-all;
}

.itemTime {
  font-size: 14px;
  color: #ff7c7c;
  font-weight: 500;
  margin-left: 10px;
  white-space: nowrap;
}

.noData {
  text-align: center;
  color: #999;
  font-size: 14px;
  padding: 40px 0;
}

.van-pagination {
  margin-top: 20px;
  justify-content: center;
}

.searchBox {
  width: 90%;
  margin: 10px auto;
  border: 1px solid #e0e0e0;
  border-radius: 30px;
}

.storeBox {
  max-height: 300px;
  overflow-y: auto;
}
</style>
